/**
 * Each year need to update this value and the assets for feed banner and
 * yearly report intro screen
 */
export const YEARLY_REPORT_YEAR = 2025;
export const YEARLY_REPORT_INTRO = `didViewYearlyReportIntro${YEARLY_REPORT_YEAR}`;
export const YEARLY_REPORT_FEED = `didDismissYearlyReportFeed${YEARLY_REPORT_YEAR}`;
